import React from 'react';
import { Star } from 'lucide-react';
export const TestimonialsSection: React.FC = () => {
  const testimonials = [{
    name: 'Mariana López',
    age: 34,
    city: 'Buenos Aires',
    country: 'Argentina',
    review: 'Llevo 8 años enseñando gimnasia artística y este pack me cambió la vida. Antes pasaba 3-4 horas cada domingo preparando las clases de la semana. Ahora en 30 minutos tengo todo listo. Los ejercicios están súper bien organizados por nivel y mis alumnas progresan mucho más rápido. ¡Lo recomiendo al 100%!'
  }, {
    name: 'Sebastián Rodríguez',
    age: 29,
    city: 'Córdoba',
    country: 'Argentina',
    review: 'La plantilla del plan anual es oro puro. Pude organizar todo mi año en una tarde y ahora los padres me ven como mucho más profesional. Además, el checklist de seguridad me da tranquilidad en cada clase. Vale cada peso.'
  }, {
    name: 'Valeria Fernández',
    age: 41,
    city: 'Rosario',
    country: 'Argentina',
    review: 'Como profesora con más de 15 años de experiencia, pensé que no necesitaba ayuda, pero este pack me sorprendió. Los ejercicios progresivos están perfectamente estructurados y la guía de comunicación con padres me ahorró tantos dolores de cabeza. Ojalá lo hubiera tenido hace años.'
  }, {
    name: 'Nicolás García',
    age: 26,
    city: 'Mendoza',
    country: 'Argentina',
    review: 'Recién empiezo como profesor de gimnasia artística y este pack fue mi salvación. Tenía mucho miedo de no saber qué enseñar o cómo organizarme, pero con este sistema me siento seguro y profesional desde el primer día. Los padres confían en mí y mis alumnos están súper motivados.'
  }, {
    name: 'Carolina Pérez',
    age: 37,
    city: 'La Plata',
    country: 'Argentina',
    review: 'Lo que más me gusta es tener TODO en un solo lugar. Antes tenía apuntes por aquí, videos guardados por allá, y siempre perdía tiempo buscando. Ahora abro el pack, elijo los ejercicios según el nivel de mis alumnas y listo. Me devolvió el disfrute de enseñar sin estrés.'
  }];
  return <section className="py-20 bg-white" data-id="element-314">
      <div className="max-w-6xl mx-auto px-4" data-id="element-315">
        <div className="text-center mb-16" data-id="element-316">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-317">
            Lo que dicen otros profesores
          </h2>
          <p className="text-xl text-gray-600" data-id="element-318">
            Resultados reales de colegas que ya están usando el sistema
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-319">
          {testimonials.map((t, index) => <div key={index} className={`bg-gray-50 p-6 rounded-2xl border border-gray-200 shadow-sm ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-320">
              <div className="flex text-yellow-400 mb-4" data-id="element-321">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-322" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-323">
                "{t.review}"
              </p>
              <div className="mt-auto border-t border-gray-200 pt-4" data-id="element-324">
                <p className="font-bold text-gray-900" data-id="element-325">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-326">
                  {t.city}, {t.country}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};